export const rollerBlinds = {
  overview: {
    titles: [
      "Phong cách và Chức năng",
      "Sự riêng tư",
      "Bảo vệ khỏi mưa và tia UV / cực tím",
      "Tính linh hoạt",
    ],
    contents: [
      "Mành Cuốn là sự dung hòa / kết hợp hoàn hảo giữa phong cách và chức năng. Chúng được lắp đặt một cách gọn gàng và an toàn. Khả năng thích ứng thẩm mỹ của Mành Cuốn đảm bảo rằng thiết kế, hoa văn và chất liệu của chúng sẽ trở nên hài hòa với bất kỳ một chủ đề nội thất nào đồng thời nâng tầm bố cục tổng thể của không gian sinh sống và làm việc của bạn.",
      "Một số loại như Mành Cuốn kín mang đến cho bạn sự riêng tư tuyệt đối bất cứ khi nào bạn cần.",
      "Mành Cuốn đóng vai trò như kem / tấm áo / bức màn chống nắng giúp bảo vệ bạn và gia đình khỏi tia UV độc hại như tia UVA và tia UVB. Ở ngoài trời, Mành Cuốn có thể giữ cho khu vực ban công của bạn khô ráo trong trời mưa và xua đuổi côn trùng một cách hiệu quả.",
      "Mành Cuốn có tính linh hoạt bởi chúng có khả năng che chắn nhiều cửa sổ cùng lúc hoặc từng cửa sổ lớn riêng lẻ. Chúng có thể được đồng bộ hóa, tách rời hay thậm chí vận hành theo một trình tự. Đối với Mành Cuốn được trang bị động cơ, chúng có thể hoạt động bằng pin có thể tái sạc hoặc nguồn điện lưới. Dù vận hành bằng cách nào thì việc điều khiển Mành Cuốn vẫn là một công việc đơn giản.",
    ],
  },
  description: {
    titles: ["", ""],
    contents: [
      "Mành Cuốn ngày càng phổ biến để đáp ứng nhu cầu và đòi hỏi khắt khe của người Việt Nam. Điểm thu hút đặc biệt của nó là sự gọn gàng. Không giống như rèm cửa, Mành Cuốn dễ dàng vệ sinh hơn và nó không bám bụi bẩn như hầu hết các loại vải rèm. Không có gì đáng ngạc nhiên, nó đã trở thành sự lựa chọn phổ biến hơn của chủ sở hữu nhà, cư dân chung cư, nhà gỗ và thậm chí cả không gian thương mại.",
      "Mặc dù được sử dụng rộng rãi trong nhà nhưng Mành Cuốn còn được dùng để ngăn cản ánh nắng gay gắt từ mặt trời ở khu vực ban công. Nếu bạn đang quan tâm về vấn đề thẩm mỹ, Mành Cuốn đem đến cho bạn vô số mẫu thiết kế phù hợp với phong cách nội thất độc đáo của riêng bạn. Rèm cửa Huy Hoàng cung cấp mẫu mã, màu sắc và hoa văn thỏa mãn trí tưởng tượng của bạn. Về phương diện chức năng, chất liệu của Mành Cuốn khá đa dạng từ việc đóng vai trò như kem chống nắng bảo vệ da khỏi tia UV độc hại đến bảo vệ sự riêng tư của bạn với chất liệu kín đáo hay thậm chí là đảm bảo ánh sáng mặt trời có thể chiếu vào bên trong với chất vải mờ. Ngoài ra, Rèm cửa Huy Hoàng còn mang đến các tùy chọn về Mành Cuốn thủ công hay vận hành bởi động cơ sử dụng hệ điều hành bậc nhất.",
    ],
  },
  summary: {
    header:
      "Simple and stylish, roller blinds are our most popular product. They’re easy to operate and maintain, and come in a number of colour ways and fabrics.",
    subItems: [
      {
        title: "BLOCKOUT ROLLER BLINDS",
        details:
          "Prevent sun light from entering any room with the specifically engineered blackout roller blinds. They’re great for optimum sleep or privacy. And parents swear by then for establishing the right sleep patterns in small children. We offer thermal blockout options to regulate heat in a room so you’re cozy in winter or cool in summer.",
      },
      {
        title: "SUNSCREEN ROLLER BLINDS",
        details:
          "Sunscreen roller blinds have a dual benefit. They cut out sunlight for glare control and provide shade to protect furnishings from harmful UV. Because they are semi-transparent you can also maintain your view while achieving privacy and light control. Available in either 3%, 5% of 10% screen, simply choose the best option for your needs.",
      },
      {
        title: "COMBINATION ROLLER BLINDS",
        details:
          "Consider combining blockout and sunscreen roller blinds on the same window to achieve the best of both worlds – complete darkness when you need it and a glare-protected view during the day.",
      },
      {
        title: "MOTORISED FOR EASE",
        details:
          "Window Answers’ roller blinds can be motorised for ease. This is a great solution if you have a large area of blinds or blinds which are difficult to access.",
      },
    ],
  },
  about: {
    header: "What we say about Roller blinds",
    col01: {
      title: "Great for…",
      items: [
        "Reducing light in bedrooms with blackout fabrics",
        "Kitchens and bathrooms with water resistant finishes",
        "Hard to reach windows or multiple blinds with motorised options",
        "Perfect Fit frames, giving a streamlined finish",
        "Skylight windows",
      ],
    },
    col02: {
      title: "Things to consider",
      items: [
        "Roller blinds are made from one piece of fabric, so they can’t be shaped around sloping or unusual windows",
        "All our Roller blinds are chain or pull-cord operated, and our advisors will fit child safety cleats as standard. Alternatively, Perfect Fit or motorised Roller blinds are cordless",
        "For a drill-free option, choose Perfect Fit blinds, which clip into your uPVC frames",
      ],
    },
  },
};
